export const CALENDLY_URL =
    process.env.REACT_APP_CALENDLY_URL?.trim() ||
    "https://calendly.com/therawmath";
